module.exports = __webpack_public_path__ + "img/158.478ecf37.jpg";